import { type GUID, type InstallationId } from '@common/types/brandedTypes';

export interface DeviceBackup {
  id: GUID;
  name: string;
  comment: string;
  installationId: InstallationId;
  createdBy: {
    email: string;
  };
  createdUtc: string;
  isReadOnly: boolean;
}

export interface GetBackupRestoresResponse {
  id: GUID;
  backupId: GUID;
  startUtc: string;
  completedUtc: string;
  restoredBy: {
    email: string;
  };
}

export enum RestoreRegisterStatus {
  Pending = 10,
  Sent = 20,
  Failed = 30,
}

export interface BackupRegisterResponse {
  registerSpecificationId: number;
  displayValue: number;
  status?: RestoreRegisterStatus;
}
